// Thin, crash-proof wrappers around PostHog (loaded via the snippet
// in public/index.html). Every call is a silent no-op until the real
// project key is set there, and can never break the app — analytics
// must never take the site down.

const ph = () => (typeof window !== "undefined" ? window.posthog : null);

export const capture = (event, props) => {
  try {
    const p = ph();
    if (p && typeof p.capture === "function") p.capture(event, props);
  } catch {
    // analytics is best-effort, always
  }
};

export const identify = (id, props) => {
  try {
    const p = ph();
    if (p && typeof p.identify === "function") p.identify(id, props);
  } catch {
    // best-effort
  }
};

export const reset = () => {
  try {
    const p = ph();
    if (p && typeof p.reset === "function") p.reset();
  } catch {
    // best-effort
  }
};
